import styled from '@emotion/styled';
import zIndices from '../../../../../lib/zIndices';
import HamburgerIcon from '../../../../Icons/HamburgerIcon';

const NavMenuButton = styled('button')`
  background-color: #fff;
  padding: 14px 30px;
  border-radius: 60px;
  filter: drop-shadow(0px 5px 12px rgba(0, 0, 0, 0.16))
    drop-shadow(0px 3px 12px rgba(0, 0, 0, 0.14));
  cursor: pointer;
  z-index: ${zIndices.desktopNavButton};
`;

const NavMenuButtonContent = styled('div')`
  display: flex;
  flex-direction: row;
  column-gap: 16px;
  align-items: center;
  justify-content: center;
`;

const NavMenuButtonText = styled('div')`
  font-size: 22px;
  color: black;
`;

interface SinglePageDesktopNavMenuButtonProps {
  onClick: () => void;
  isMenuOpen: boolean;
}

const SinglePageDesktopNavMenuButton = ({
  onClick,
  isMenuOpen,
}: SinglePageDesktopNavMenuButtonProps) => {
  return (
    <NavMenuButton
      onClick={onClick}
      data-testid="SinglePage__DesktopNav__MenuButton"
    >
      <NavMenuButtonContent>
        <HamburgerIcon isOpen={isMenuOpen} color="black" />
        <NavMenuButtonText>Menu</NavMenuButtonText>
      </NavMenuButtonContent>
    </NavMenuButton>
  );
};

export default SinglePageDesktopNavMenuButton;
